import { render } from "./chameleon.vue?vue&type=template&id=69c48fc2"
const script = {}

import "./chameleon.vue?vue&type=style&index=0&id=69c48fc2&lang=css"

import exportComponent from "/Users/voltz/Documents/Github/Website/CraftMasters/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__